let resumeData = {
  imagebaseurl: "https://pujanshah22.github.io/site",
  name: "Pujan Shah",
  role: "React Native and MERN Stack Developer",
  linkedinId: "https://www.linkedin.com/in/pujanshah22",
  skypeid: "skype:pujanshahcena?chat",
  roleDescription:
    " I like to play with mathematical formulas to develop a better product along with learning about new technologies or simply play chess in my free time.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/pujanshah22",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "http://github.com/pujanshah22",
      className: "fa fa-github",
    },
  ],
  aboutme:
    "I am currently working as an expert React Native and MERN Stack Developer. I like to dive deeper into future technologies. I take the challenges with the belief that everything is possible and you're the only one who can do this. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
  address: "India",
  website: "https://pujanshah22.github.io/site",
  education: [
    {
      UniversityName: "SAL Institute of Technology and Engineering Research",
      specialization: "Computer Engineering",
      MonthOfPassing: "2013 - ",
      YearOfPassing: "2017",
    },
    {
      UniversityName: "Vijayanager School - GSEB",
      specialization: "Science A group",
      MonthOfPassing: "",
      YearOfPassing: "2013",
    },
  ],
  work: [
    {
      CompanyName: "Razorpay",
      specialization: "Senior Software Engineer",
      MonthOfLeaving: "Nov 2020 - ",
      YearOfLeaving: "Present",
      Achievements:
        "Explored neo banking space by working in RazorpayX business unit. Have built mobile applications for RazorpayX in React Native. Also plays an active role in handling graphQL backend. To provide easy access of neo-banking solutions, currently developing & leading Apple Watch app development.",
    },
    {
      CompanyName: "Technostacks InfoTech Pvt Ltd",
      specialization: "React Native & MERN Stack Developer",
      MonthOfLeaving: "Sep 2018 - ",
      YearOfLeaving: "Oct 2020",
      Achievements:
        "I was leading the team of React Native along with working on React Native, React JS and Node JS projects. I also handled client communication and requirements gathering for projects. I got a chance to work for an onsite project in ex-Google Developers's company. ",
    },
    {
      CompanyName: "Praxinfo",
      specialization: "React Native & Native Android Developer",
      MonthOfLeaving: "Apr 2017 - ",
      YearOfLeaving: "Sep 2018",
      Achievements:
        "I was a junior developer in Praxinfo but never felt like junior. Here, I always got a chance to share my point of view on the requirement. As a team, we got so many achievements in challenging projects.",
    },
    {
      CompanyName: "Tops Technology",
      specialization: "Android Trainee",
      MonthOfLeaving: "June 2016 - ",
      YearOfLeaving: "Mar 2017",
      Achievements:
        "I was working here as an android trainee. I made my basics powerful in this company. Along with training, my senior team helped me to learn php for the backend.",
    },
  ],
  skillsDescription: "Your skills here",
  skills: {
    frontEnd: [
      "React Native",
      "React JS",
      "JSX",
      "Javascript",
      "TypeScript",
      "Hooks",
      "ECMAScript",
      "CSS",
      "SASS",
      "Redux",
      "Redux-Saga",
      "Redux-Thunk",
      "BootStrap",
      "React-Navigation",
      "XML",
      "Native Android",
      "iOS",
      "java",
    ],
    backEnd: [
      "Node JS",
      "Express JS",
      "Mongoose",
      "Heroku",
      "AWS",
      "Firebase",
      "GraphQL",
    ],
    database: [
      "MongoDB",
      "NoSQL",
      "MySQL",
      "Firebase Cloud Firestore",
      "Real Time Database",
      "AWS",
      "SQLite",
      "Realm",
    ],
    payment: ["Razorpay", "Stripe", "Cahsfree", "Bluesnap", "Paypal"],
    others: [
      "Augmented Reality",
      "AWS-IoT",
      "MQTT",
      "BLE",
      "WIFI Connection",
      "Smart-Config",
      "Socket IO",
      "Image Recognition",
    ],
  },
  portfolio: [
    {
      name: "project1",
      description: "mobileapp",
      imgurl: "images/portfolio/phone.jpg",
    },
    {
      name: "project2",
      description: "mobileapp",
      imgurl: "images/portfolio/project.jpg",
    },
    {
      name: "project3",
      description: "mobileapp",
      imgurl: "images/portfolio/project2.png",
    },
    {
      name: "project4",
      description: "mobileapp",
      imgurl: "images/portfolio/phone.jpg",
    },
  ],
  testimonials: [
    {
      description:
        "Pujan finds a way to weather any storm with a smile. No matter how complex the problem is, he always comes up with a brilliant and cost-effective solution. He is a truly remarkable individual.",
      name: "Mentor",
    },
    {
      description:
        "'Age is just a number' is a suitable quote for him. He has gained so much knowledge in a very young age. I've had the opportunity of knowing Pujan for the past. Broad-minded Developer - his exceptional work flow, skills, ingenuity and knowledge of change requests made the project a dream. Loyal, insightful and independent. He showed a high level of React native technical skills and was a valuable contributor to our projects. Pujan possesses a winning combination of solid tech skills and business sense, I learned a great deal from him. I certainly would recommend him as React Native Developer.",
      name: "Senior colleague",
    },
  ],
};

export default resumeData;
